export const PURCHASE_SHIPMENT_SUCCESS = "PURCHASE_SHIPMENT_SUCCESS";
export const PURCHASE_SHIPMENT_REQUEST = "PURCHASE_SHIPMENT_REQUEST";
export const PURCHASE_SHIPMENT_FAILURE = "PURCHASE_SHIPMENT_FAILURE";
export const purchaseShipmentSuccess = (payload) => ({
    type: PURCHASE_SHIPMENT_SUCCESS,
    payload,
});
export const purchaseShipmentRequest = (payload) => ({
    type: PURCHASE_SHIPMENT_REQUEST,
    payload,
});
export const purchaseShipmentFailure = (payload) => ({
    type: PURCHASE_SHIPMENT_FAILURE,
    payload,
});
